import IconArrowCircleRight from "@/icons/IconArrowCircleRight";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import React from "react";

export function PlusButton({
  label,
  onClick
}: {
  label?: string;
  onClick(): void;
}) {
  return (
    <button
      className={
        "btn-sm border rounded-full h-5 flex justify-center hover:border-cornflower-blue-200 hover:scale-125 hover:cursor-pointer"
      }
      onClick={onClick}
    >
      <span className="group-hover:scale-125">
        <i className="fa fa-plus fa-xs mr-1" />
        {label}
      </span>
    </button>
  );
}

export function MinusButton({
  label,
  onClick
}: {
  label?: string;
  onClick(): void;
}) {
  return (
    <button
      className={
        "btn-sm border rounded-full h-5 flex justify-center hover:border-cornflower-blue-200 hover:scale-125 hover:cursor-pointer"
      }
      onClick={onClick}
    >
      <span className="group-hover:scale-125">
        <i className="fa fa-minus fa-xs mr-1" />
        {label}
      </span>
    </button>
  );
}

export function NextButton({
  label,
  onClick
}: {
  label?: string;
  onClick(): void;
}) {
  return (
    <PrimaryBlueButton
      label={label}
      onClick={onClick}
      suffixIcon={<IconArrowCircleRight />}
    />
  );
}
